export const InfoTeaserWidgetId = 'InfoTeaserWidget';

export enum InfoTeaserWidgetAttributes {
  LINK = 'infoTeaserLink',
  MEDIA = 'infoTeaserMedia',
  HEADLINE = 'infoTeaserHeadline',
  TEXT = 'infoTeaserText',
  ICON = 'infoTeaserIcon',
}
